import { AutoAddCompanyToWatchlist } from './AutoAddCompanyToWatchlist';
export default AutoAddCompanyToWatchlist;
